import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DoctorSocialService } from '../doctor-social.service';
import { AppService } from 'src/app/app.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-interest-dialog',
  templateUrl: './interest-dialog.component.html',
  styleUrls: ['./interest-dialog.component.css']
})
export class InterestDialogComponent implements OnInit {

  form: FormGroup;

  searchControl = new FormControl('');

  selectedChips = []

  ObjFiltered;
  resObj;

  constructor(
    public dialogRef: MatDialogRef<InterestDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private service: DoctorSocialService,
    public app: AppService,
    private toaster: ToastrService,
  ) { }

  ngOnInit(): void {
    this.form = new FormGroup({
      categories: new FormControl("", Validators.required),
    });
    this.getInterests();
  }

  get = (formControlName: string) => this.form.get(formControlName) as FormControl;


  getInterests() {
    this.service.getCategories().subscribe(
      res => {
        this.resObj = res?.data
        this.ObjFiltered = res?.data
      }
    )

  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  onChangeSelection(e, obj) {
    if (e?.checked) {
      this.selectedChips.push(obj)
    } else if (!e?.checked) {
      this.removeChip(obj)
    }
  }

  removeChip(obj) {
    let x = this.selectedChips.filter(item => item?.id !== obj?.id);
    this.selectedChips = x
  }

  submit() {
    const arrayOfIds: number[] = this.selectedChips.map(obj => obj.id);
    this.get("categories").setValue(arrayOfIds)
    if (arrayOfIds.length > 0) {
      this.service.linkCategoryWithHcp(this.form.value).subscribe(
        res => {
          if (res.errorCode == 0) {
            if (this?.app?.getUserLanguage() == 'en') {
              this.toaster.success("Saved Successfully");
            } else if (this?.app?.getUserLanguage() == 'ar') {
              this.toaster.success("تم الحفظ");
            }
            this.dialogRef.close(true);
          } else {
            this.dialogRef.close(false);
            this.toaster.error(res.errorMessage);
          }
        }
      )
    }

  }

  onInputChange() {
    if (this.searchControl.value.length > 0) {
      let z = this.resObj.filter(item => item?.name.includes(this.searchControl.value));
      this.ObjFiltered = z
    } else if (this.searchControl.value.length == 0) {
      this.ObjFiltered = this.resObj
    }
  }

}
